import * as yup from 'yup';
import { signupFormSchema } from './constants';

export enum CustomerFormType {
  LOGIN,
  REGISTER,
}

export type SignupForm = yup.Asserts<typeof signupFormSchema>;
